import { render } from "./splash_page.vue?vue&type=template&id=a13cbe20&scoped=true"
import script from "./splash_page.vue?vue&type=script&lang=js"
export * from "./splash_page.vue?vue&type=script&lang=js"

import "./splash_page.vue?vue&type=style&index=0&id=a13cbe20&scoped=true&lang=css"

import exportComponent from "/Users/danramage/Documents/workspace/WaterQuality/RiverWQApp_Vue/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a13cbe20"]])

export default __exports__